// extracted by mini-css-extract-plugin
export default {"footerWrapper":"NotificationFooter_footerWrapper__EGXed","contentContainer":"NotificationFooter_contentContainer__dprTe","logoFooter":"NotificationFooter_logoFooter__vUrZw"};